export default "__VITE_ASSET__CiyEUZ4z__"